<template>
  <div class="prod">
    <div class="ln_head">
      <img class="header_logo" :src="require('@/assets/imgs/pay/header_logo.png')" alt="" />
    </div>
    <div class="prod_b">
      <div class="part-title">{{ $t('paySubmit.paymenMethod') }}</div>

      <!-- <div class="payWay">
        <div v-if="pmx_show == 0" class="payWay_a"><img src="../../assets/imgs/xsolla.png" alt="" /></div>
        <div v-if="pmx_show == 1" class="payWay_a"><img src="../../assets/imgs/payerMax.png" alt="" /></div>
        <div class="payWay_b"><img src="../../assets/imgs/pay1-1.png" alt="" /></div>
      </div> -->

      <div class="payWay" v-for="(item, index) in payWays" :key="index" @click="changePayWay(index)">
        <div class="payWay_a"><img :src="item.icon" alt="" /></div>
        <div class="payWay_b" v-if="item.checked"><img src="../../assets/imgs/pay1-1.png" alt="" /></div>
        <div class="payWay_b" v-if="!item.checked"><img src="../../assets/imgs/pay1.png" alt="" /></div>
      </div>
    </div>

    <div class="prod_b prod_c">
      <div class="part-title">{{ $t('paySubmit.prodDetails') }}</div>
    </div>
    <div class="prod_a" style="background: #fff;">
      <div class="img"><img :src="detailData.product_file_url" alt="" /></div>
      <div class="desc">
        <div>{{ detailData.product_name }}</div>
        <div>
          <span v-if="area_val == 'kr'">₩</span>
          <span v-if="area_val != 'kr'">$</span>
          {{ detailData.amount }}
        </div>
      </div>
    </div>

    <!-- 没选角色时，进这个页面之前做了判断必须确认角色，并且这里加了display:none，所以该片段不显示 -->
    <div class="prod_b prod_c" v-if="!isRole" style="display: none">
      <div>
        <i></i>
        <span>Delivering Address</span>
      </div>
      <div class="prod_padding">
        <div class="prod_flex" v-if="pa_game">
          <div>Area</div>
          <div class="prod_select">
            <select name="" id="" v-model="area_id" @change="getServers">
              <option value="us" label="NA">NA</option>
              <option value="eu" label="Europe">Europe</option>
            </select>
          </div>
        </div>

        <div class="prod_flex" style="margin-top: 0.5rem">
          <div>Server</div>
          <div class="prod_select">
            <select name="" id="" v-model="server_id">
              <option :value="item.server_id" v-for="(item, index) in serveList" :key="index"
                >{{ item.server_name }}
              </option>
            </select>
          </div>
        </div>

        <div class="prod_flex" v-if="game_id != '136' && game_id != '14' && game_id != '18'">
          <div>Character Name</div>
          <div class="prod_flex_input">
            <input type="text" v-model="role_name" placeholder="Please fill in your character name " />
          </div>
        </div>

        <div class="prod_flex" v-if="game_id == '136' || game_id == '14' || game_id == '18'">
          <div>
            Character ID
            <img
              style="width: 0.4rem;vertical-align: middle"
              @click="openRolePop"
              src="../../assets/imgs/question.png"
              alt=""
            />
          </div>
          <div class="prod_flex_input">
            <input type="text" v-model="role_id" placeholder="Please fill in your character id" />
          </div>
        </div>
      </div>
      <div class="prod_role_btn" @click="confirmRole">Confirm</div>
    </div>

    <!-- 上面那段不显示，没办法改变isRole，所以该片段也不显示 -->
    <div class="prod_b prod_c" v-if="isRole" style="background: #f1f1f1;">
      <div class="role_cont">
        <div class="role_cont_a">
          <p>You will recharge/</p>
          <p>purchase items for the following characters:</p>
          <p class="weight">Server: {{ roleInfo.server_name }} , {{ roleInfo.role_id }}, {{ roleInfo.role_name }}</p>
          <p class="weight">Code: {{ roleInfo.role_id }}</p>
          <p>
            <img style="width: .29rem;vertical-align: middle;" src="../../assets/imgs/pay_sure.png" alt="" /> Please
            confirm the server, role name, ID, and purchased item before submitting the order. After the item is
            successfully traded, if you recharge the wrong character, you will not be able to transfer
          </p>
          <p style="margin-top: 0.15rem">
            Matters needing attention： 1. After completing the purchase, the purchased item will be sent to your
            account in around 10s. Please enter the game to check. If you didn't get purchased items in your account,
            please record the Xsolla order number and tap on the floating butto-n to the right to contact customer
            service； 2. If you are a minor under the age of 18, you must obtain the consent of your parents before
            purchas-ing and using the store service.
          </p>
        </div>
      </div>
    </div>

    <div class="prod_b prod_c" style="margin-bottom: 0.3rem;">
      <div class="part-title">{{ $t('paySubmit.discount') }}</div>

      <div class="prod_padding" style="padding-top: 0;">
        <div class="prod_flex">
          <div class="prod_flex_input">
            <input
              type="text"
              v-model="discount_code"
              style="width: 3rem;"
              :placeholder="$t('paySubmit.discountCode')"
            />
          </div>
          <div class="enterBtn" @click="discountCode">{{ $t('common.confirm') }}</div>
        </div>
      </div>
    </div>

    <div class="prod_e">
      <div class="cont">
        <div v-if="!money">
          {{ $t('paySubmit.total') }}:
          <span v-if="area_val == 'kr'">₩</span>
          <span v-if="area_val != 'kr'">$</span>
          {{ detailData.amount }}
        </div>
        <div v-if="money">
          {{ $t('paySubmit.total') }}:
          <span v-if="area_val == 'kr'">₩</span>
          <span v-if="area_val != 'kr'">$</span>
          {{ money }}
        </div>
        <div @click="submitOrder">{{ $t('paySubmit.submit') }}</div>
      </div>
    </div>

    <!-- 角色ID教程弹窗 -->
    <div class="roleIdPop" v-if="isRolePop" @click="isRolePop = false">
      <img :src="roleImgUrl" @click.stop alt="" />
    </div>

    <cust></cust>
  </div>
</template>

<script>
// import { getServerList, getRoleInfo, submitPay, valDiscountCode } from '@/api/api';
import { mapState } from 'vuex';
import { axiosServer } from '@/api/http';
import { getSign } from '@/api/utils';
import { getUrlParams } from '@/utils';
import { Dialog, Toast, ImagePreview } from 'vant';
import cust from '../../components/customer.vue';
import { useDialog } from '../../features/dialog/use-dialog';

export default {
  data() {
    return {
      detailData: {},
      serveList: [],
      isRole: false,
      role_name: '',
      server_id: '',
      server_sign: '',
      roleInfo: {},
      area_id: 'us',
      code: '',
      game_id: localStorage.getItem('game_id'),
      area_val: localStorage.getItem('area'),
      pmx_show: '',
      role_id: '',
      discount_code: '',
      money: '',
      codeEnter: false,
      pa_game: false,
      app_key: '1df869f2e620513484ddbd5521313a60',
      payWays: JSON.parse(localStorage.getItem('payWays')),
      isRolePop: false,
      roleImgUrl: '',
      region: '',
    };
  },
  components: {
    cust
  },
  computed: {
    // ...mapState(['payWays'])
  },
  setup() {
    const { confirmDialog } = useDialog();
    return {
      confirmDialog
    };
  },
  created() {
    this.pmx_show = this.$route.query.pmx_show || '';
    // console.log(this.pmx_show);
    this.detailData = this.$route.query || {};
    // this.pa_game = this.game_id == 18 && (this.area_val == 'us' || this.area_val == 'eu');
    // console.log(this.detailData);
    this.roleInfo = this.detailData.roleInfo && JSON.parse(this.detailData.roleInfo);
    this.server_sign = this.$route.query.server_sign || '';
    this.region = this.$route.query.region || '';
    this.getServers();
  },
  methods: {
    getServers() {
      let post_area = this.pa_game ? this.area_id : localStorage.getItem('area');
      axiosServer({
        url: 'getServerList',
        type: 'post',
        params: {
          game_id: this.game_id,
          area: post_area,
          sign: getSign(this.app_key, { game_id: this.game_id, area: post_area })
        }
      }).then(resa => {
        let res = resa.data;
        if (res.ret == 0) {
          this.serveList = res.data;
          this.server_id = localStorage.getItem('server_id') || res.data[0].server_id || '';
          this.role_name = localStorage.getItem('role_name') || '';
          this.role_id = localStorage.getItem('role_id') || '';
        } else {
          this.confirmDialog({ message: res.msg });
        }
      });
    },
    changePayWay(index) {
      this.payWays.forEach(v => {
        v.checked = false;
      });
      this.$set(this.payWays[index], 'checked', true);
    },
    reportEvent(event) {
      let params = {
        game_id: localStorage.getItem('game_id'),
        area: localStorage.getItem('area'),
        product_id: this.detailData.id,
        product_type: this.detailData.type,
        report_type: event,
        from: localStorage.getItem('from')
      };
      axiosServer({
        url: 'report',
        type: 'post',
        params: {
          ...params,
          sign: getSign(this.app_key, params)
        }
      }).then(res => {
        console.log(res);
      });
    },
    openRolePop() {
      if (this.game_id == '14') {
        this.roleImgUrl = require('../../assets/imgs/role_jlsy.jpg');
      } else if (this.game_id == '136') {
        this.roleImgUrl = require('../../assets/imgs/role_wyqt.jpg');
      } else if (this.game_id == '18') {
        this.roleImgUrl = require('../../assets/imgs/role_lmzt.jpg');
      }
      // this.isRolePop = true;
      ImagePreview({ images: [this.roleImgUrl], closeable: true });
    },
    discountCode() {
      if (!this.discount_code) {
        this.confirmDialog({
          message: this.$t('paySubmit.fillDiscountCode')
        });
        return;
      }
      const params = {
        role_id: this.roleInfo.role_id || this.role_id,
        amount: this.detailData.amount,
        discount_code: this.discount_code,
        product_id: this.detailData.id,
        area: this.pa_game ? this.area_id : localStorage.getItem('area'),
        game_id: this.game_id
      };
      axiosServer({
        url: 'valDiscountCode',
        type: 'post',
        params: {
          ...params,
          sign: getSign(this.app_key, params)
        }
      }).then(resa => {
        let res = resa.data;
        this.codeEnter = true;
        if (res.ret == 0) {
          this.money = res.data.money;
        } else {
          this.confirmDialog({
            message: res.msg
          });
        }
      });
      // valDiscountCode(params).then(res => {
      //   this.codeEnter = true;
      //   if (res.ret == 0) {
      //     this.money = res.data.money;
      //   } else {
      //     Dialog.alert({ message: res.msg });
      //   }
      // });
    },
    confirmRole() {
      // if (!this.role_name && this.game_id != '136' && this.game_id != '14' && this.game_id != '18') {
      //   Dialog.alert({ message: 'Please fill in your character name' });
      //   return;
      // }
      // if (!this.role_id && (this.game_id == '136' || this.game_id == '14' || this.game_id == '18' )) {
      //   Dialog.alert({ message: 'Please fill in your character id' });
      //   return;
      // }
      let params =
        this.game_id == '136' || this.game_id == '14' || this.game_id == '18'
          ? {
              role_id: this.role_id,
              server_id: this.server_id,
              area: this.pa_game ? this.area_id : localStorage.getItem('area'),
              game_id: this.game_id
            }
          : {
              role_name: this.role_name,
              server_id: this.server_id,
              area: this.pa_game ? this.area_id : localStorage.getItem('area'),
              game_id: this.game_id
            };

      axiosServer({
        url: 'getRoleInfo',
        type: 'post',
        params: {
          ...params,
          sign: getSign(this.app_key, params)
        }
      }).then(resa => {
        let res = resa.data;
        if (res.ret == 0) {
          this.isRole = true;
          console.log(res.data);
          this.roleInfo = res.data;
        } else {
          this.confirmDialog({
            message: res.msg
          });
        }
      });
    },
    submitOrder() {
      this.reportEvent(5);
      // if (!this.role_name && this.game_id != '136' && this.game_id != '14' && this.game_id != '18' ) {
      //   Dialog.alert({ message: 'Please fill in your character name' });
      //   return;
      // }
      // if (!this.role_id && (this.game_id == '136' || this.game_id == '14' || this.game_id == '18' )) {
      //   Dialog.alert({ message: 'Please fill in your character id' });
      //   return;
      // }
      // localStorage.setItem('server_id', this.server_id);
      // localStorage.setItem('role_name', this.roleInfo.role_name || this.role_name);
      // localStorage.setItem('role_id', this.roleInfo.role_id || this.role_id);
      if (this.discount_code && !this.codeEnter) {
        const paramsCode = {
          game_id: this.game_id,
          role_id: this.roleInfo.role_id || this.role_id,
          amount: this.detailData.amount,
          discount_code: this.discount_code,
          product_id: this.detailData.id,
          area: this.pa_game ? this.area_id : localStorage.getItem('area')
        };

        axiosServer({
          url: 'valDiscountCode',
          type: 'post',
          params: {
            ...paramsCode,
            sign: getSign(this.app_key, paramsCode)
          }
        }).then(resa => {
          let res = resa.data;
          this.codeEnter = true;
          if (res.ret == 0) {
            this.money = res.data.money;
          } else {
            this.confirmDialog({
              message: res.msg
            });
          }
          this.payCommonFunc();
        });
        // valDiscountCode(paramsCode).then(res => {
        //   this.codeEnter = true;
        //   if (res.ret == 0) {
        //     this.money = res.data.money;
        //   } else {
        //     Dialog.alert({ message: res.msg });
        //   }
        //   this.payCommonFunc();
        // });
      } else {
        this.payCommonFunc();
      }
    },
    payCommonFunc() {
      Toast.loading();
      console.log(this.roleInfo);
      let params = {
        order_name: this.detailData.product_name,
        amount: this.detailData.amount,
        money: this.money ? this.money : this.detailData.amount,
        server_id: this.roleInfo.server_id,
        server_name: this.roleInfo.server_name,
        role_name: this.roleInfo.role_name || this.role_name,
        product_id: this.detailData.shop_mark,
        platform: this.detailData.platform,
        pay_type: this.payWays.filter(item => item.checked)[0].name,
        // pay_type: 'payermax',
        role_id: this.roleInfo.role_id || this.role_id,
        discount_code: this.discount_code,
        area: this.pa_game ? this.area_id : localStorage.getItem('area'),
        game_id: this.game_id,
        from: localStorage.getItem('from'),
        ...(this.game_id == '134' && {server_sign: this.server_sign}),
        ...(this.game_id == '284' && {region: this.region}),
      };
      axiosServer({
        url: 'submitPay',
        type: 'post',
        params: {
          ...params,
          sign: getSign(this.app_key, params)
        }
      }).then(resa => {
        let res = resa.data;
        Toast.clear();
        if (res.ret == 0) {
          location.href = res.data.pay_url;
        } else {
          this.confirmDialog({
            message: res.msg
          });
        }
      });
      // submitPay(params).then(res => {
      //   Toast.clear();
      //   if (res.ret == 0) {
      //     location.href = res.data.pay_url;
      //   } else {
      //     Dialog.alert({ message: res.msg });
      //   }
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
.prod {
  background: #f1f1f1;

  .part-title {
    padding-bottom: 0; // 这个页面下的part_title都不需要padding-bottom
    padding-left: 0.18rem;
  }

  .ln_head {
    background: white;
    height: 1.09rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.45rem;
    border-bottom: 0.03rem solid #f1f1f1;
    .header_logo {
      width: 3.56rem;
    }
  }

  .prod_a {
    display: flex;
    padding: 0.25rem 0.46rem;

    .img {
      position: relative;

      img {
        width: 1.59rem;
      }
    }

    .desc {
      margin-left: 0.2rem;

      div:nth-child(1) {
        color: #010101;
        font-size: 0.28rem;
      }

      div:nth-child(2) {
        color: #ff0600;
        font-size: 0.34rem;
        margin-top: 0.1rem;
      }
    }
  }

  .prod_b {
    background: #fff;
    padding: 0.13rem 0.28rem;

    div {
      line-height: 0.5rem;
    }

    div i {
      width: 0.12rem;
      height: 0.5rem;
      background: #4378ff;
      display: inline-block;
      vertical-align: top;
    }

    div span {
      margin-left: 0.13rem;
      font-size: 0.28rem;
      color: #010101;
    }

    .payWay {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 0 0;

      .payWay_a {
        img {
          width: 2.74rem;
        }
      }

      .payWay_b {
        img {
          width: 0.32rem;
        }
      }
    }

    .role_cont {
      padding: 0.2rem 0rem 0.5rem;

      .role_cont_a {
        background: #f7d5bc;
        padding: 0.25rem 0.2rem;
        border-radius: 0.15rem;
        font-size: 0.28rem;
        color: #010101;

        .weight {
          font-size: 0.32rem;
          font-weight: bold;
          margin: 0.15rem 0;
        }
      }
    }
  }

  .prod_c {
    margin-top: 0.2rem;

    .prod_padding {
      padding: 0.2rem 0.2rem;

      .prod_flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.24rem;
        color: #010101;
        margin: 0.15rem 0;

        .prod_select select {
          border: 0;
          appearance: none;
          outline: none;
          width: 1.5rem;
          text-align: right;
          font-size: 0.22rem;
          background: none;
          color: #010101;
        }

        .prod_flex_input {
          flex: 1;
          margin: 0 0.4rem;
          input {
            height: 0.9rem;
            width: 100%;
            outline: none;
            border: none;
            font-size: 0.24rem;
          }
        }

        .enterBtn {
          border: 0.02rem solid #ff0000;
          color: #ff0000;
          text-align: center;
          line-height: 0.3rem;
          padding: 0.05rem 0.1rem;
        }
      }
    }

    .prod_role_btn {
      width: 100%;
      height: 0.73rem;
      background: #4378ff;
      color: #fff;
      text-align: center;
      line-height: 0.73rem;
      font-size: 0.28rem;
    }
  }

  .prod_d {
    margin-top: 0.2rem;
    background: #fff;
    padding: 0.18rem 0.28rem;
    color: #010101;
    font-size: 0.28rem;

    .weight {
      font-weight: bold;
    }

    .margin {
      margin-top: 0.38rem;
    }
  }

  .prod_e {
    position: fixed;
    bottom: 0;
    left: 50%;
    max-width: 7.2rem;
    transform: translate(-50%, 0);
    height: 1.05rem;
    width: 100%;
    background: #fff;
    border-top: 0.03rem solid #f1f1f1;

    .cont {
      padding: 0 0.28rem 0 0.68rem;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;

      font-family: SourceHanSansCN;
      font-weight: 400;
      font-size: 0.24rem;
      color: #ffffff;

      div:nth-child(1) {
        color: #010101;
      }

      div:nth-child(2) {
        width: 1.75rem;
        height: 0.54rem;
        background: #ff0000;
        line-height: 0.54rem;
        color: #fff;
        text-align: center;
        border-radius: 0.1rem;
        cursor: pointer;
      }
    }
  }
  .roleIdPop {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    img {
      width: 90%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
